(function ($) {

    $(document).ready(function () {
        $('.portfolio-wrap .portfolio-filter-search .load-more').on('click', function(e){
            e.preventDefault();
        })

        $(document).on('click', '.portfolio-filter .full-nav li span', function(){
            var current = $(this);
            if (!current.hasClass('active')) {
                $('.portfolio-filter .full-nav li span').removeClass('active');
                current.addClass('active');
            }
        });
        $('.portfolio-filter .filter ul h6').click(function(){
           var curr = $(this);
           if(!curr.hasClass('active')){
               $('.portfolio-filter .filter ul h6').addClass('active');
               $('.portfolio-filter .filter ul li span').removeClass('active');
           }
        });
        if (window.matchMedia("(max-width: 767px)").matches) {
            $('.filter-outer .full-nav > li > span').addClass('has-menu');
            $('.full-nav-inside').addClass('sub-menu');
        } else {
            $('.filter-outer .full-nav > li > span').removeClass('has-menu');
            $('.full-nav-inside').removeClass('sub-menu');
        }

        //Trigger industry filter
        $("#portfolio-industry .sub-menu.portfolio-filter-dropdown > li").on("click", function (a) {
            var $id = $(this).text();
            $("#portfolio-industry .sub-menu.hidden-filter li").each(function () {
                var $filter_text = $(this).text();
                if ($filter_text === $id) {
                    $(this).trigger("click");
                }
            });
        });
        $("#portfolio-expertise .sub-menu.portfolio-filter-dropdown > li").on("click", function (a) {
            var $id = $(this).text();
            $("#portfolio-expertise .sub-menu.hidden-filter li").each(function () {
                var $filter_text = $(this).text();
                if ($filter_text === $id) {
                    $(this).trigger("click");
                }
            });
        });
    });

    $(document).ready(function () {
        open_dropbox();
        close_dropbox();
        $('.filter .main-menu .sub-menu').click(function (e) {
            if($(e.target).parent().hasClass('js-sub-menu-with-dropdown')) {
                $('.js-sub-menu-with-dropdown').removeClass('open');
                $(e.target).parent().addClass('open');
            }
            e.stopPropagation();
        });
        // $('.filter .full-nav .sub-menu').click(function (e) {
        //     e.stopPropagation();
        // });
    });

// Toggle submenus open and close
    function open_dropbox() {
        $(document).on('click', '.filter .has-menu', function(e){
            e.stopPropagation();
            resetSubMenu();
            $(this).parents(".filter-wrap").addClass("active");
            $(this).parent().toggleClass('menu-active');
            $(this).parent().find('.sub-menu').stop(true, true).slideToggle();
            $('.filter .has-menu').not(this).parent().find('.sub-menu').slideUp();
            $('.filter .has-menu').not(this).parent().removeClass('menu-active');
            $('.filter .main-menu .has-menu').not(this).parent().removeClass('rotate-arrow');
            $(this).parent().toggleClass('rotate-arrow');
        });
    }

    function resetSubMenu() {
        $('.js-sub-menu-with-dropdown').removeClass('open');
    }



// Toggle desktop-menus open and close
    function close_dropbox() {
        $(document).click(function () {
            resetSubMenu();
            $('.filter .main-menu .sub-menu').slideUp();
            $('.filter .main-menu li').removeClass('menu-active');
            $('.filter .main-menu .has-menu').parent().removeClass('rotate-arrow');
            $('.filter .full-nav .sub-menu').slideUp();
            $('.filter .full-nav li').removeClass('menu-active');
            $('.filter .full-nav .has-menu').parent().removeClass('rotate-arrow');
            $('.filter .filter-wrap').removeClass("active");
        });
    }
    function search_input(){
        $('body .portfolio-filter .filter-nav .filter-wrap.search-outer form .search-input').on('keyup',function () {
            var inputLength = ($(this).val()).length;
            if(inputLength>0){
                $("body .portfolio-filter .filter-nav .filter-wrap.search-outer form button.cross-outer").show();
            }else{
                $("body .portfolio-filter .filter-nav .filter-wrap.search-outer form button.cross-outer").hide();
            }
        });
        $("body .portfolio-filter .filter-nav .filter-wrap.search-outer form button.cross-outer").on("click",function () {
            $('body .portfolio-filter .filter-nav .filter-wrap.search-outer form .search-input').val('');
        });
    }
    $(window).on('load', function () {
        search_input();
        $(window).on("resize", function () {
            if (window.matchMedia("(max-width: 767px)").matches) {
                $('.filter-outer .full-nav > li > span').addClass('has-menu');
                $('.full-nav-inside').addClass('sub-menu');
            } else {
                $('.filter-outer .full-nav > li > span').removeClass('has-menu');
                $('.full-nav-inside').removeClass('sub-menu');
            }
            var windowWidth = jQuery(window).width();
            if (windowWidth >= 768) {
                close_dropbox();
                $('.filter .main-menu > li').addClass('arrow');
                $('.filter .main-menu > li').removeClass('menu-active rotate-arrow');
            }
            $(".filter .main-menu .sub-menu").removeAttr("style");
        });



    });

})(jQuery);